var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('p',[_vm._v("Picked the wrong subscription? Shop around then come back to pay!")])])
}]

export { render, staticRenderFns }